import { ArchiveEyeOutlineIcon } from './ArchiveEyeOutlineIcon';

/**
 * author: Colton Wiscombe
 * id A61C4171-FA5D-4273-A1F5-72CC6506BE70
 * name archive-eye-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/archive-eye-outline.svg
 * tags
 */
export const BoxEyeOutlineIcon = ArchiveEyeOutlineIcon;
export default BoxEyeOutlineIcon